/**
 * Users Routes
 */
/* eslint-disable */
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

// async components
import {
    AsyncPrevRiesgoDocumentosCategoriasManagementComponent,
    AsyncPrevRiesgoDocumentosManagementComponent 
} from 'Components/AsyncComponent/AsyncComponent';

const Forms = ({ match }) => (
    <div className="content-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/documentos-management`} />
            <Route path={`${match.url}/documentos-categorias-management`} component={AsyncPrevRiesgoDocumentosCategoriasManagementComponent} />
            <Route path={`${match.url}/documentos-management`} component={AsyncPrevRiesgoDocumentosManagementComponent} />
        </Switch>
    </div>
);

export default Forms;
